<template>
  <div
    class="input-select"
    :class="'col-md-' + col"
    :style="{ margin: marginSpace }"
  >
    <label>{{ label }}</label>
    <div class="input" @click="openSelect = !openSelect" ref="select">
      <span v-if="!selectedValues.length">Selecione</span>
      <div
        class="showValuesSelect"
        v-else
        v-for="(value, index) in selectedValues"
        :key="index"
      >
        <span>{{ value.name }}</span>
      </div>
      <div class="button">
        <button v-if="selectedValues.length" @click.prevent="removeAll" @click.stop>
          <ion-icon name="close-circle-outline"></ion-icon>
        </button>
        <button v-if="openSelect == false" @click.prevent="openSelect = !openSelect" @click.stop>
          <ion-icon name="chevron-down-outline"></ion-icon>
        </button>
        <button v-else @click.prevent="openSelect = !openSelect" @click.stop>
          <ion-icon name="chevron-up-outline"></ion-icon>
        </button>
      </div>
    </div>
    <div class="list-container" v-if="openSelect">
      <div class="box-search">
        <input class="search" type="search" v-model="search" placeholder="Digite o nome" @click.stop/>
        <ion-icon v-if="!search.length" name="search-outline"></ion-icon>
      </div>
      <div
        class="row-label"
        v-for="(option, index) in filteredItems"
        :key="index"
      >
        <label @click="select(option)">
          {{ option.name }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listItems: {
      required: true,
    },
    label: {
      default: '',
    },
    col: {
      required: true,
    },
    marginSpace: {
      default: '',
    },
  },
  data() {
    return {
      selectedValues: [],
      selectedString: '',
      openSelect: false,
      search: '',
    };
  },
  methods: {
    select(option) {
      if (this.selectedValues.length) {
        this.selectedValues = [];
        this.selectedValues.push(option);
        this.selectedString = this.selectedValues.map(value => value.id).toString();
      } else {
        this.selectedValues.push(option);
        this.selectedString = this.selectedValues.map(value => value.id).toString();
      }
      this.openSelect = false;
    },
    removeAll() {
      this.selectedValues = [];
      this.selectedString = '';
    },
    handleOutsideClick(event) {
      if (!this.$refs.select.contains(event.target)) {
        this.openSelect = false;
      }
    },
  },
  watch: {
    selectedValues(newValue, oldValue) {
      this.$emit('selectedValues', newValue);
    },
    selectedString(newValue, oldValue) {
      this.$emit('selectedString', newValue);
    }
  },
  beforeMount() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  computed: {
    filteredItems() {
      const search = this.search.toLowerCase();
      return this.listItems.filter((item) =>
        item.name.toLowerCase().includes(search)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.input-select {
  position: relative;
  text-align: start;

  label {
    display: block;
    font-size: 14px;
    font-weight: 400;
    color: var(--border-gray);
    margin-bottom: 4px;
  }

  .input {
    width: 100%;
    height: 36.84px;
    background: #eef2f7;
    padding: 6px 12px;
    border-radius: 5px !important;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 16px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    position: relative;

    &:hover {
      box-shadow: inset 0 0 0 1px #cacaca;
    }

    &:focus-visible {
      outline: none;
      border: 1px solid #cacaca;
    }

    .button {
      position: absolute;
      right: 12px;
      top: 12px;
    }

    button {
      padding: 0;
      background: none;
      border: none;
      cursor: pointer;
    }
  }

  .list-container {
    position: absolute;
    width: 100%;
    background: #eef2f7;
    border: 1px solid #7c7c7c;
    border-radius: 0 0 5px 5px !important;
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 12px 0;
    box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.2);
    margin-top: 0;
    max-height: 300px;
    overflow-y: scroll;
    z-index: 2;

    .box-search {
      width: 100%;
      position: relative;

      .search {
        width: 96%;
        padding: 6px;
        margin: 0 auto 6px 12px;
        border: none;
        border-radius: 4px !important;
        font-size: 14px;

        &:focus {
          box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.5);
          outline: none;
        }
      }

      ion-icon {
        position: absolute;
        top: 8px;
        font-size: 16px;
        right: 16px;
      }
    }

    .row-label {
      width: 100%;
      text-align: start;

      label {
        display: block;
        padding: 0 12px 0 12px;
        margin-bottom: 0;
        font-weight: 400;
        font-size: 16px;
        color: #3a424e;
        cursor: pointer;
        width: inherit;
        box-sizing: border-box;

        &:hover {
          color: #ffffff;
        }
      }

      &:hover {
        background: #1967d2;
        color: #ffffff;
      }
    }
  }

  .list-container::-webkit-scrollbar {
    width: 8px;
  }

  .list-container::-webkit-scrollbar-thumb {
    background: #9c9c9c;
    border-radius: 4px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/inputs/inputSelectSearch.vue